export const footerData = {
    en: {    // Changed to match context key 'en'
        contactUs: "Contact Us",
        phone: "+95 9 404 229 673",
        email: "info@mahãvihãrahlegu.com",
        location: "Location",
        address: "Mahãvihãra Hlegu",
        viewMap: "Click to view on Google Maps",
        followUs: "Follow Us",
        rights: "All rights reserved.",
        developedBy: "Developed by"
    },
    my: {    // Changed to match context key 'my'
        contactUs: "ဆက်သွယ်ရန်",
        phone: "+၉၅ ၉ ၄၀၄ ၂၂၉ ၆၇၃",
        email: "info@mahãvihãrahlegu.com",
        location: "တည်နေရာ",
        address: "မဟာဝိဟာရ လှည်းကူး",
        viewMap: "Google Maps တွင် ကြည့်ရှုရန် နှိပ်ပါ",
        followUs: "လူမှုကွန်ရက်များ",
        rights: "All rights reserved.",
        developedBy: "Developed by"
    }
};

export const socialLinks = [
    {
        name: "facebook",
        url: "https://www.facebook.com/share/18LiAM2bnG/",
        icon: "fab fa-facebook"
    },
    {
        name: "youtube",
        url: "https://youtube.com",
        icon: "fab fa-youtube"
    }
];

export const contactInfo = {
    phone: "+959404229673",
    email: "info@mahãvihãrahlegu.com",
    mapUrl: "https://maps.app.goo.gl/yHnKMqchvQqhqUUg6"
};